import React, { CSSProperties, Ref, ReactNode } from 'react';
import styled from 'styled-components';
import { path } from 'ramda';

type Props = {
  elemRef?: Ref<HTMLDivElement>;
  height?: number;
  title?: string;
  children: ReactNode;
  style?: CSSProperties;
  wrraperStyle?: CSSProperties;
  titleStyle?: CSSProperties;
};

const CardWrapper = styled.div<{ height?: number }>`
  padding: 20px;
  background-color: ${path(['theme', 'colors', 'grey', 'lighter'])};
  border-radius: 5px;
  width: 100%;
  ${(props) => (props.height ? `height: ${props.height}px` : '')};
`;

const StyledText = styled.div<{ isTitle?: boolean }>`
  ${(props) => props?.isTitle && `font-size: ${props.theme.font.size.h3}`};
  color: ${(props) => props.theme.colors.secondary.main};
  font-weight: bold;
  margin-bottom: 4px;
`;

const CardSendCommunication: React.FC<Props> = ({
  elemRef,
  height,
  title,
  children,
  style,
  wrraperStyle,
  titleStyle,
}: Props) => (
  <div style={style}>
    {title && <StyledText style={titleStyle}>{title}</StyledText>}
    <CardWrapper ref={elemRef} height={height} style={wrraperStyle}>
      {children}
    </CardWrapper>
  </div>
);

export default CardSendCommunication;
